'use strict';

// jQuery is loaded via jquery-standalone.js
const processInclude = require('base/util');

require('./common');
$(() => {
    processInclude(require('base/components/spinner'));
    processInclude(require('./components'));
    processInclude(require('./experience'));
    processInclude(require('./product/quickView'));
    processInclude(require('./pages'));
    processInclude(require('./login'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/wishlistList'));
    processInclude(require('./account'));
    processInclude(require('./order'));
    // processInclude(require('./orderHistory')); // already included in history.isml
    processInclude(require('./clerkSession'));
});

require('./personalization/personalization');